// extracted by mini-css-extract-plugin
module.exports =  {"container":"_33974c2b58--container--nObdM","icon":"_33974c2b58--icon--PnURh"};